"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Graphics = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
var inputId = 'graphics-overlay-url';
var Label = function (_a) {
    var label = _a.label;
    return label
        ? react_1.default.createElement(react_1.default.Fragment, null, label)
        : react_1.default.createElement(storybook_1.Icons.Icon, { name: 'clipboard', className: 'w-5 float-right mr-2' });
};
var Graphics = function (_a) {
    var url = _a.url;
    var _b = react_1.useState(false), copied = _b[0], setCopied = _b[1];
    return (react_1.default.createElement("div", { className: 'storybook-producer-graphics' },
        react_1.default.createElement(storybook_1.Buttons.Copy, { id: inputId, label: react_1.default.createElement(Label, { label: copied ? 'copied!' : false }), placeholder: 'Start een livestream en kopieer graphics url', value: url, onClick: function () {
                var input = document.getElementById(inputId);
                copy_to_clipboard_1.default(input.value || '', {
                    debug: true
                });
                setCopied(true);
                setTimeout(function () { return setCopied(false); }, 750);
            } }),
        react_1.default.createElement("span", { className: 'clear-both' })));
};
exports.Graphics = Graphics;
exports.Graphics.propTypes = {
    url: prop_types_1.default.string
};
exports.Graphics.defaultProps = {
    url: ''
};
